// extracted by mini-css-extract-plugin
export default {"bulletSeparatedList":"BulletSeparatedList_bulletSeparatedList__Xo2Br"};